// For Make Log on Develop Mode

import { useAuthStore } from '@/stores/authStore.ts'

export function logOnDev(message: unknown) {
  if (import.meta.env.MODE === 'development') {
    console.log(message)
  }
}

export function isUserLoggedSuperAdminOrAdmin() {
  const role = useAuthStore().userRole()
  return role == 'super_admin' || role == 'admin'
}

export function isUserLoggedSuperAdmin() {
  return useAuthStore().userRole() == 'super_admin'
}

export function isUserLoggedAdmin() {
  return useAuthStore().userRole() == 'admin'
}

export function isUserLoggedCustomer() {
  return useAuthStore().userRole() == 'customer'
}

export function getDateFromStringYear(year: string | null) {
  if (year) {
    return new Date(parseInt(year), 0, 1)
  }
}

export function getDateForServer(date: Date | null) {
  if (!date) return null

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

export function getDateTimeForServer(date: Date) {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}T${date.getHours()}:${date.getMinutes()}:00`
}

export function getDateFromStringForServer(date: string) {
  return date.replace(' ', 'T').substring(0, 10)
}

/**
 * @param date 2025-02-18T15:58:00.000+01:00
 * @return 2025-02-18
 */
export function getDateFromServerString(date: string) {
  return date.substring(0, 10)
}

/**
 * @param date 2025-02-18T15:58:00.000+01:00
 * @return 2025-02-18 15:58
 */
export function getDateTimeFromServerString(date: string) {
  return date.substring(0, 16).replace('T', ' ')
}

export function getNowDatetimeForServer() {
  const date = new Date()
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}T${date.getHours()}:${date.getMinutes()}:00`
}

// get size of a file
export function humanFileSize(size: number) {
  const i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024))
  return (
    +(size / Math.pow(1024, i)).toFixed(2) +
    ' ' +
    ['B', 'kB', 'MB', 'GB', 'TB'][i]
  )
}

// check if file is a PDF
export function isPdfFile(filename: string) {
  // return (filename.split('.').pop())?.toLowerCase() === 'pdf'
  return filename.toLowerCase().includes('.pdf')
}

export function formatStringServerDateFromDate(value: Date) {
  return value.toLocaleDateString('it-IT')
}

// manage errors from server
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function manageErrorResponse(error: any) {
  const defaultMessage = 'Errore di connessione con il server'
  // check error
  if (
    error != null &&
    error.response != null &&
    error.response.status != null
  ) {
    if (
      error.response.status === 502 ||
      error.response.status === 500 ||
      error.response.status === 404
    ) {
      return defaultMessage
    } else {
      const data = error.response.data
      if (data?.message && !data?.errors) {
        return data.message
      }
      let message = ''
      // check json object
      if (Object.keys(data.errors).length !== 0) {
        // is json object
        message = data.errors
      } else {
        // is array
        Array.prototype.forEach.call(data.errors, (element) => {
          message += element + ' | '
        })
        // manage
        message = message.substring(0, message.length - 3)
      }
      return message
    }
  } else {
    return defaultMessage
  }
}

// get today date string
export function getTodayString() {
  return new Date().toISOString().slice(0, 10)
}

// get date from string
export function formatDateFromString(value: string) {
  return value != undefined
    ? new Date(value).toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    : ''
}

export function formatDateTimeFromString(value: string) {
  // check null
  if (value == null || value == '') return '-'
  // ...ok!
  return new Date(value).toLocaleDateString('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  })
}

/**
 *
 * @param value string YYYY-MM-DD
 * @return string DD/MM/YYY
 */
export function formatStringDateFromYYYYMMDD(value: string) {
  if (value == '' || !value.includes('-')) {
    return ''
  }
  const valueArray = value.split('-')
  return `${valueArray[2]}/${valueArray[1]}/${valueArray[0]}`
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function manageMultipartFormData(params: any, modelName: string) {
  // check for multipart form
  // create multipart
  const formData = new FormData()
  // populate form data with key-value
  Array.prototype.forEach.call(Object.keys(params), (key) => {
    // check if key has a valid value
    if (
      params[key] != null &&
      !(
        Object.keys(params[key]).length === 0 &&
        params[key].constructor === Object
      )
    ) {
      // is nested_attributes?
      if (
        key === 'suppliers_attributes' ||
        key === 'gprs_modules_attributes' ||
        key === 'probes_attributes' ||
        key === 'fuel_pumps_attributes'
      ) {
        // Each element of the array has to be passed using []
        Array.prototype.forEach.call(params[key], (attribute) => {
          // destroy a device already present?
          if (attribute._destroy) {
            // yes, delete
            formData.append(modelName + '[' + key + '][][id]', attribute.id)
            formData.append(modelName + '[' + key + '][][_destroy]', 'true')
          } else {
            // no, add because is new
            formData.append(modelName + '[' + key + '][][id]', attribute.id)
            formData.append(modelName + '[' + key + '][][_destroy]', 'false')
          }
        })
      } else if (key === 'document_attributes') {
        // document_attributes is not documents_attributes
        // Each element of the array has to be passed using []
        formData.append(
          modelName + '[' + key + '][document]',
          params[key].document
        )
        formData.append(modelName + '[' + key + '][label]', params[key].label)
        formData.append(
          modelName + '[' + key + '][typology]',
          params[key].typology
        )
      } else if (key === 'vehicle_group_ids') {
        // Each element of the array has to be passed using []
        Array.prototype.forEach.call(params[key], (attribute) => {
          formData.append(modelName + '[' + key + '][]', attribute)
        })
      } else {
        // not a nested attributes, classic key-value (not null or empty)
        formData.append(modelName + '[' + key + ']', params[key])
      }
    }
  })
  // back
  return formData
}

export function pad2(n: number) {
  return n < 10 ? '0' + n : n
}

export function getNowYYYYMMDDHHMMSSFormat() {
  const date = new Date()
  return (
    date.getFullYear().toString() +
    pad2(date.getMonth() + 1) +
    pad2(date.getDate()) +
    pad2(date.getHours()) +
    pad2(date.getMinutes()) +
    pad2(date.getSeconds())
  )
}

export function createScopesString(scopes?: string[]) {
  if (scopes == null || scopes.length === 0) {
    return ''
  }
  let scopesInUrl = ''
  scopes.forEach((scope) => {
    if (scope != null && scope != '') {
      scopesInUrl += `&scopes[]=${scope}`
    }
  })
  return scopesInUrl
}

export function createFilterScopesString(filterScopes?: Map<string, string>) {
  if (filterScopes == null) {
    return ''
  }
  let scopesInUrl = ''
  filterScopes.forEach((value, key) => {
    if (value != null && value != '') scopesInUrl += `&${key}=${value}`
  })
  return scopesInUrl
}

export function isObjectEmpty(item: object) {
  return Object.keys(item).length === 0 && item.constructor === Object
}

export function parseJwt(token: string | null) {
  if (token == null) return ''
  const base64Url = token!.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(jsonPayload)
}

export function prepareSort(
  sortParams?: { field: string; order: number | string } | null
) {
  return sortParams?.field
    ? JSON.stringify({
        [sortParams.field]: sortParams.order
      })
    : null
}

export function getNowYYYYMMDDHHMMFormat() {
  const date = new Date()
  return (
    date.getFullYear().toString() +
    pad2(date.getMonth() + 1) +
    pad2(date.getDate()) +
    pad2(date.getHours()) +
    pad2(date.getMinutes())
  )
}

export function getHoursAndMinutesFromSeconds(valueInSeconds: string | null) {
  const totalSeconds = parseInt(valueInSeconds || '0', 10)

  if (isNaN(totalSeconds)) {
    return { hours: 0, minutes: 0 }
  }

  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60)
      .toString()
      .padStart(2, '0')
  }
}

export function getSecondsFromHoursAndMinutes(
  hours: number | 0,
  minutes: number | 0
) {
  return hours * 3600 + minutes * 60
}
